import { observer } from 'mobx-react';
import { TextConstants } from '../../TextConstants';
import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import FileDownloadComponentVM from './FileDownloadComponentVM';

interface IFileDownloadComponentProps {
    viewModel: FileDownloadComponentVM;
    onDownloadCSV: () => void;
}

@observer
export default class FileDownloadComponent extends React.Component<IFileDownloadComponentProps> {
    public render() {
        return (
            <div className="text-right">
                <Neo.Button className="form-btn float-right col-md-2 mt-0 mb-0"
                    onClick={() => this.props.onDownloadCSV()}
                    variant="secondary" icon="far-file-alt">
                    {TextConstants.Buttons.DownloadCSV}
                </Neo.Button>
            </div>
        )
    }
}